import type { RouteRecordRaw } from 'vue-router';
import { AppPermissions } from '@/utils/permissions';

export const studentReportRoute: RouteRecordRaw = {
  path: 'reports/students',
  name: 'admin-student-reports',
  component: () => import('@/views/AdminDashboard/StudentListReportView.vue'),
  meta: {
    requiresAuth: true,
    title: 'Student Reports',
    permission: {
      action: AppPermissions.Students.Actions.View,
      resource: AppPermissions.Students.Resource,
    },
  },
};
